import { z } from 'zod';

/** Политика пароля сервера (NIST: только длина). Сервер проверяет её сам; здесь — для подсказки. */
export const newPasswordSchema = z
  .string()
  .min(10, 'validation.passwordTooShort')
  .max(256, 'validation.tooLong');
